import type { ComponentSchema } from "../../../../../schema-types"
import { primaryButtonFields, outlineButtonFields } from "../shared/button-schema-fields"

export const schema: ComponentSchema = {
  type: 'product-detail',
  label: 'Product Detail',
  description: 'The main product information page section.',
  supportedPages: ['product'],
  variants: [{ id: 'v1', label: 'V1 (Classic Info Grid)' }],
  commonFields: [
    { key: 'loadingText', label: 'Loading Text', type: 'string', default: 'Loading Data...' },
    { key: 'notFoundCode', label: 'Not Found Code', type: 'string', default: '404' },
    { key: 'notFoundText', label: 'Not Found Text', type: 'string', default: 'Product Not Found' },
    { key: 'quantityLabel', label: 'Quantity Label', type: 'string', default: 'Quantity' },
    { key: 'productDescTitle', label: 'Product Description Accordion Title', type: 'string', default: 'Product Description' },
    { key: 'returnPolicyTitle', label: 'Return Policy Accordion Title', type: 'string', default: 'Return Policy' },

    // ─── Buttons ──────────────────────────────────────────────────────
    ...primaryButtonFields('buttons.addToCart', 'Add to Cart Button'),
    ...outlineButtonFields('buttons.orderNow', 'Order Now Button'),
  ],
}
